import { render, staticRenderFns } from "./detail_class.vue?vue&type=template&id=54662262&scoped=true&"
import script from "./detail_class.vue?vue&type=script&lang=js&"
export * from "./detail_class.vue?vue&type=script&lang=js&"
import style0 from "./detail_class.vue?vue&type=style&index=0&id=54662262&scoped=true&lang=css&"
import style1 from "./detail_class.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54662262",
  null
  
)

export default component.exports